var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "v-navigation-drawer",
          attrs: {
            clipped: "",
            app: "",
            right: "",
            "mobile-breakpoint": "900"
          },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { tile: "", flat: "" } },
            [
              _c(
                "v-card-title",
                { staticClass: "font-weight-light justify-center" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "pa-2", attrs: { color: "green" } },
                    [_vm._v("mdi-comment-text-multiple")]
                  ),
                  _vm._v("Comentarios")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { attrs: { tile: "", flat: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  solo: "",
                  label: "Buscar",
                  flat: "",
                  "background-color": "#eee",
                  "prepend-inner-icon": "mdi-magnify"
                },
                model: {
                  value: _vm.filterWord,
                  callback: function($$v) {
                    _vm.filterWord = $$v
                  },
                  expression: "filterWord"
                }
              })
            ],
            1
          ),
          _c(
            "v-scroll-y-transition",
            { attrs: { group: "" } },
            _vm._l(this.getComments, function(i, key) {
              return _c(
                "div",
                { key: key },
                [
                  _vm.showStepName(key)
                    ? _c("h2", { staticClass: "overline text-center" }, [
                        _vm._v(" " + _vm._s(i.stepName) + " ")
                      ])
                    : _vm._e(),
                  _c("Comment", {
                    attrs: { color: _vm.colors[i.stepID - 1], text: i.comment }
                  }),
                  _vm.showDivider(key)
                    ? _c("v-divider", { staticClass: "mb-2" })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _vm._t("default"),
          _c(
            "v-btn",
            _vm._g(
              {
                class: {
                  "overline drawer-comment-icon__fixed": true,
                  "drawer-comment-icon__not-fixed": this.drawer
                },
                attrs: { absolute: "", right: "", ripple: false },
                on: {
                  click: function() {
                    return (this$1.drawer = !this$1.drawer)
                  }
                }
              },
              _vm.on
            ),
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-icon", { staticClass: "pa-1", attrs: { small: "" } }, [
                    _vm._v("mdi-comment-text-multiple-outline")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }